// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"858b2e58","423":"f5872905","453":"fb59f69c"}[chunkId] + ".chunk.js";
};